import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import styles from '../GeoBrowse.module.css';

type BackLinkProps = {
  to: string;
  label: string;
};

export default function BackLink({ to, label }: BackLinkProps) {
  return (
    <Link to={to} className={styles.backLink}>
      <ChevronLeftIcon width={16} height={16} aria-hidden />
      {label}
    </Link>
  );
}
